export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9594.456dca65.jpg";